export default "__VITE_ASSET__BOsHyzSs__"